<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import LoggingSessions from "./tabs/LoggingSessions.vue";
import LoggingAction from "./tabs/LoggingAction.vue";
import DataLogging from "./tabs/DataLogging.vue";
import { getLogItem } from "@/entities/logging";
import { getRoleList } from "@/entities/role";
import Button from "@/shared/ui/button/Button.vue";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";

export default {
  name: "LoggingItem",
  components: {
    LoadingOverlay,
    BaseTabs,
    LoggingSessions,
    DataLogging,
    LoggingAction,
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
  },
  data() {
    return {
      loading: false,
      activeTab: "action",
      logItem: null,
      roles: [],
      tabs: {
        action: {
          label: this.$t("Действие"),
          icon: "huge-text-config",
        },
        data: {
          label: this.$t("Метаданные"),
          icon: "huge-unlock",
        },
        active_sessions: {
          label: this.$t("Активные сессии"),
          icon: "huge-unlock",
        },
      },
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    currentLang() {
      return this.$i18n.locale;
    },
    titleKey() {
      return {
        kk: "name_kz",
        ru: "name",
        en: "name_en",
      }[this.currentLang];
    },
    roleName() {
      return this.getRoleName(this.logItem?.user?.role);
    },
    actions() {
      return [
        {
          label: "Отправить уведомление",
          type: "default",
          action: "edit",
          icon: "huge-pen2",
        },
        {
          label: "Загрузить отчёт по сессиям",
          type: "default",
          action: "view",
          icon: "huge-eye",
        },
        {
          label: "Завершить сессию",
          type: "danger",
          action: "block",
          icon: "huge-close",
          isLast: true,
        },
        {
          label: "Завершить все сессии",
          type: "danger",
          action: "remove",
          icon: "huge-danger",
        },
      ];
    },
    currentTabComponent() {
      const tabComponents = {
        action: LoggingAction,
        data: DataLogging,
        active_sessions: LoggingSessions,
      };

      return tabComponents[this.activeTab] || null;
    },
  },

  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab) {
          this.activeTab = tab;
        }
      },
    },
  },

  created() {
    this.loadLogData();
    this.fetchRoles();
  },

  methods: {
    async fetchRoles() {
      try {
        const data = await getRoleList();
        if (data?.payload?.items) {
          this.roles = data.payload.items;
        }
      } catch (e) {
        console.error("Failed fetch roles", e);
      }
    },
    getRoleName(code) {
      if (!code) return this.$t("Не указано");
      const role = this.roles.find((r) => r.code === code);

      return role ? role[this.titleKey] : code;
    },
    async loadLogData() {
      this.loading = true;
      try {
        if (this.uuid) {
          this.logItem = await getLogItem(this.uuid);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setTimeout(() => (this.loading = false), 500);
      }
    },
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
    handleActions() {},
  },
};
</script>

<template>
  <div class="main">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
        <template #action>
          <div class="flex items-center gap-3">
            <!-- TODO: временно скрыто — нет реализации на бэкенде -->
            <!-- <Button variant="outline" size="icon">
              <svg-icon name="huge-print" class="w-4 h-4 text-foreground" />
            </Button> -->
            <!-- <Button variant="outline" size="icon">
              <svg-icon name="huge-download" class="w-4 h-4 text-foreground" />
            </Button> -->

            <!-- TODO: временно скрыто — нет реализации на бэкенде -->
            <!-- <DropdownMenu>
              <DropdownMenuTrigger as-child>
                <Button variant="default">
                  {{ $t("Операции") }}
                  <svg-icon name="huge-down" class="w-5 h-5 ml-2 text-white" />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="end" class="w-[282px]">
                <template v-for="item in actions" :key="item.label">
                  <DropdownMenuSeparator v-if="item.isLast" />

                  <DropdownMenuItem
                    :variant="
                      item.type === 'danger' ? 'destructive' : undefined
                    "
                    @click="
                      handleActions({
                        action: item.action,
                        uuid: uuid,
                        rowData: logItem,
                      })
                    "
                    class="!p-0 !m-0"
                  >
                    <div class="item">
                      <svg-icon
                        v-if="item.icon"
                        :name="item.icon"
                        class="w-5 h-5"
                        :class="item.type ? item.type : ''"
                      />

                      <span :class="item.type ? item.type : ''">
                        {{ $t(item.label) }}
                      </span>
                    </div>
                  </DropdownMenuItem>
                </template>
              </DropdownMenuContent>
            </DropdownMenu> -->
          </div>
        </template>
      </BaseTabs>
    </div>

    <component
      :is="currentTabComponent"
      :logItem="logItem"
      :roles="roles"
      :roleName="roleName"
      ref="activeForm"
      class="w-full h-full flex-1"
    />
  </div>
</template>

<style scoped lang="scss">
.main {
  @apply w-full h-full flex flex-col gap-6;

  .button {
    @apply h-10 flex justify-center items-center p-4 bg-card border;
    @apply border-border rounded outline-none;
    &:active {
      transform: scale(0.98);
    }
  }
}

.item {
  @apply flex items-center px-3 py-2 gap-3 rounded-lg cursor-pointer transition-colors;
  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply text-base font-medium leading-6 text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
